import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import { graphql } from 'gatsby';
import React from 'react';

interface RiveImageProps {
  position?: string;
  fit?: string;
  block: {
    rive_image: string;
    rive_state_machine_name: string;
    rive_autoplay: boolean;
  };
  shouldDisableRiveListeners?: boolean;
  classNames?: string;
}

export const riveImageQuery = graphql`
  fragment RiveFragment on Block {
    rive_image
    rive_state_machine_name
    rive_autoplay
  }
`;

const RiveImage: React.FC<RiveImageProps> = ({
  position,
  fit,
  block,
  classNames,
  shouldDisableRiveListeners = false,
}) => {
  let layoutAlignment: Alignment = Alignment.CenterLeft;
  if (position === 'center') {
    layoutAlignment = Alignment.Center;
  } else if (position === 'right') {
    layoutAlignment = Alignment.TopRight;
  } else if (position === 'left') {
    layoutAlignment = Alignment.TopLeft;
  }
  let layoutFit: Fit = Fit.Contain;
  if (fit === 'cover') {
    layoutFit = Fit.Cover;
  }
  const { RiveComponent } = useRive({
    src: block.rive_image,
    stateMachines: block.rive_state_machine_name,
    autoplay: block.rive_autoplay,
    useOffscreenRenderer: true,
    shouldDisableRiveListeners,
    layout: new Layout({
      fit: layoutFit,
      alignment: layoutAlignment,
    }),
  });

  return <RiveComponent className={`base-canvas-size ${classNames}`} />;
};

export default RiveImage;
